<template>
    <div class="js-image-text-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'imageTextList' }">图文信息</router-link>
                </li>
                <li class="active">(添加/修改)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules" label-width="100px">
                <el-form-item label="类型" prop="type">
                    <el-select v-model="saveModel.type">
                        <el-option v-for="(item, index) in imageTextTypes" :key="index" :label="item.label" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图标" v-show="(saveModel.type && saveModel.type.indexOf('BANNER') != -1)">
                    <el-upload :action="serverUrl + '/file/upload'" :on-success="uploadSuccess" :data="uploadData" :limit="1">
                        <el-button size="small" type="primary" icon="el-icon-upload">上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="标题" prop="title" v-show="(saveModel.type && (saveModel.type == 'BANNER_SHOP_AD' || saveModel.type.indexOf('BANNER') == -1))">
                    <el-input type="text" v-model="saveModel.title" placeholder="标题"></el-input>
                </el-form-item>
                <el-form-item label="链接" v-show="(saveModel.type && saveModel.type.indexOf('BANNER') != -1)">
                    <el-input type="text" v-model="saveModel.remark"></el-input>
                </el-form-item>
                <el-form-item label="内容" v-if="'SINGLE_PAGE' == saveModel.type || 'HELP_CENTER' == saveModel.type || 'ANNOUNCEMENT' == saveModel.type">
                    <UEditor :content="ueditorContent" ref="ueditor"></UEditor>
                </el-form-item>
                <el-form-item label="排序" prop="seq" v-show="'SINGLE_PAGE' != saveModel.type">
                    <el-input type="number" v-model="saveModel.seq" placeholder="排序"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="saveImageText('formName')">确认</el-button>
                    <el-button size="small"  @click="resetForm('formName')">重置</el-button>
                    <el-button size="small" @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import UEditor from '@/components/ueditor.vue';
export default {
    components: {
        UEditor,
    },
    data() {
        return {
            imageTextId: '',
            saveModel: {},
            imageTextTypes: [],
            attaches: [],
            uploadData: { folder: '', fileNamePre: 'imageText' },
            userInfo: {},
            serverUrl: config.hostUrl,
            ueditorContent:'',
            rules:{
                type:[{required: true, message: "请选择类型", trigger: "blur"}]
            },
        }
    },
    created() {
        var _this = this;
        _this.userInfo = _this.$common.user_info();
        _this.imageTextId = _this.$route.query.imageTextId;
        _this.imageTextTypes = _this.$common.enum_config('EImageTextType');
    },
    mounted() {
        var _this = this;
        _this.$nextTick(function() {
            if (_this.imageTextId) {
                _this.detailImageText();
            } 
        });
    },
    methods: {
        getContent: function(){
          var _this = this; 
          let content = _this.$refs.ueditor.getUEContent();
          _this.saveModel.remark = content;
          console.log(content);
        },
        uploadSuccess(res, file) {
            this.$set(this.saveModel, 'iconPath', res.msg);
        },
        attachUploadSuccess(res, file) {
            var _this = this;
            _this.attaches.push({
                path: res.msg,
                remark: file.name
            });
        },
        deleteAttach(_index) {
            this.attaches.splice(_index, 1);
        },
        detailImageText() {
            var _this = this;
            _this.$common.my_ajax({
                url: 'imageText/detailImageText',
                data: {
                    imageTextId: _this.imageTextId
                },
                success: function(response) {
                    _this.saveModel = response.item;
                    _this.ueditorContent = _this.saveModel.remark;
                }
            });
        },
        saveImageText(_fromName) {
            var _this = this;
            if('SINGLE_PAGE' == _this.saveModel.type || 'HELP_CENTER' == _this.saveModel.type || 'ANNOUNCEMENT' == _this.saveModel.type){
                _this.getContent();
            }
            _this.$refs[_fromName].validate((valid)=>{
                if(valid){
                    _this.$common.my_ajax({
                    url: 'imageText/saveImageText',
                    contentType: 'application/json',
                    data: _this.saveModel,
                    success: function(response) {
                        _this.$message({
                            message: '保存成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.$router.push({ name: 'imageTextList' });
                            }
                        });
                    }
                });
                }else{
                    return false;
                }
            });
        },
        resetForm(_fromName){
            this.$refs[_fromName].resetFields();
        },
    },
}
</script>
<style scoped>
.color-highlight {
    color: red;
}
</style>